import { colors } from './theme';

export function formatRelativeTime(dateString) {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return 'N/A';
  const diffMs = Date.now() - date.getTime();
  const diffSeconds = Math.round(diffMs / 1000);
  const thresholds = [
    { unit: 'day', seconds: 86400 },
    { unit: 'hour', seconds: 3600 },
    { unit: 'minute', seconds: 60 },
    { unit: 'second', seconds: 1 }
  ];
  const formatter = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  for (const { unit, seconds } of thresholds) {
    if (Math.abs(diffSeconds) >= seconds || unit === 'second') {
      const value = Math.round(diffSeconds / seconds) * -1;
      return formatter.format(value, unit);
    }
  }
  return 'N/A';
}

export function getStatusBadgeStyle(status) {
  const normalized = (status || '').toString().trim().toUpperCase();
  const baseStyle = {
    display: 'inline-block',
    padding: '0.15rem 0.6rem',
    borderRadius: '999px',
    fontSize: '0.85rem',
    fontWeight: 600,
    letterSpacing: '0.05em'
  };
  if (normalized === 'PASS') {
    return { ...baseStyle, backgroundColor: colors.success, color: colors.background };
  }
  if (normalized === 'FAIL') {
    return { ...baseStyle, backgroundColor: colors.danger, color: colors.background };
  }
  return { ...baseStyle, backgroundColor: colors.muted, color: colors.background };
}

export const POC_FIELD_LABELS = {
  serialNumber: 'Serial Number',
  serviceTagNumber: 'Service Tag Number',
  productNumber: 'Product Number',
  model: 'Model',
  workorder: 'Workorder',
  scandate: 'Scandate',
  scanby: 'Scan By',
  testStatus: 'Test Status',
  testDate: 'Test Date',
  testBy: 'Tested By',
  poNumber: 'PO Number',
  saleOrder: 'Sale Order',
  drawingDIU: 'Drawing DIU',
  workDIU: 'Work DIU',
  cusPnDIU: 'Customer PN DIU',
  snDisplayCabinet: 'SN Display Cabinet',
  snDisplay: 'SN Display',
  snColor: 'SN Color',
  drawingELU: 'Drawing ELU',
  workELU: 'Work ELU',
  cusPnELU: 'Customer PN ELU',
  snElu: 'SN ELU',
  mainBoard: 'Main Board',
  multiPowerBoard: 'Multi Power Board',
  topPcbBoard: 'Top PCB Board',
  serialSsd: 'Serial SSD',
  ssdType: 'SSD Type',
  serialRam: 'Serial RAM',
  ramType: 'RAM Type',
  ingested_at: 'Ingested At'
};

export const POC_FIELD_SECTIONS = [
  {
    title: 'Overview',
    keys: ['serialNumber', 'serviceTagNumber', 'productNumber', 'model', 'workorder']
  },
  {
    title: 'Test Information',
    keys: ['testStatus', 'scandate', 'scanby', 'testDate', 'testBy']
  },
  {
    title: 'Orders',
    keys: ['poNumber', 'saleOrder', 'workDIU', 'workELU']
  },
  {
    title: 'Display Components',
    keys: ['drawingDIU', 'cusPnDIU', 'snDisplayCabinet', 'snDisplay', 'snColor']
  },
  {
    title: 'Electronics',
    keys: ['drawingELU', 'cusPnELU', 'snElu', 'mainBoard', 'multiPowerBoard', 'topPcbBoard', 'serialSsd', 'ssdType', 'serialRam', 'ramType']
  }
];
